import { Title, theme } from '@huspy/forge';
import {
  Flex, rem, Stack
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import useApplicationsList from '@modules/opportunities/entities/bankApplication/query/useBankApplicationsKanbanList';
import Loader from '@shared/loader';
import { BankApplicationsKanbanRoute } from '@modules/opportunities/presentation/routes';
import { useLayoutStore } from '@modules/core/store';
import { CaseSlido } from '@modules/opportunities/presentation/pages/CaseCreation/features/CaseSlido';
import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { Board, BoardType } from '@modules/opportunities/presentation/pages/BankApplicationsKanban/features/KanbanBoard/components/Board';
import ControlPanel from '@modules/opportunities/presentation/pages/BankApplicationsKanban/features/ControlPanel';

export const BankApplicationKanban = () => {
  const { t } = useTranslation();
  const q = BankApplicationsKanbanRoute.useSearch();
  const {
    data, isLoading, fetchNextPage, hasNextPage, isFetching,
  } = useApplicationsList(q);
  const { featureFlags, isFeatureActive } = useFeatureFlags();

  const reducedData = data?.pages.reduce((acc, page) => ({
    // @ts-ignore
    response: {
      ...acc.response,
      submitted: [...acc.response.submitted, ...page.response.submitted],
      approved: [...acc.response.approved, ...page.response.approved],
      completed: [...acc.response.completed, ...page.response.completed],
      processed: [...acc.response.processed, ...page.response.processed],
    },
  }), {
    response: {
      paging: {},
      submitted: [],
      approved: [],
      completed: [],
      processed: [],
    },
  });

  const containerData: BoardType = {
    submitted: reducedData?.response.submitted || [],
    approved: reducedData?.response.approved || [],
    completed: reducedData?.response.completed || [],
    processed: reducedData?.response.processed || [],
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
  };

  const { setHeaderContent } = useLayoutStore();
  useEffect(() => {
    if (isFeatureActive('opportunities.caseCreation')) {
      setHeaderContent(<CaseSlido />);
      return () => {
        setHeaderContent(null);
      };
    }
  }, [setHeaderContent, featureFlags, isFeatureActive]);

  return (
    <Flex direction='column'>
      <Flex bg='neutral.1' py={ theme.spacing['2xl'] }>
        <Flex justify='space-between' align='center' style={ { width: '100%', padding: `0 ${theme.spacing['2xl']}` } }>
          <Title size='h4' fw={ 600 }>{t('kanban.title')}</Title>
        </Flex>
      </Flex>
      <Stack
        p={ theme.spacing['2xl'] }
        align='center'
        justify='space-between'
        gap={ theme.spacing.xl }
      >
        <Flex
          justify='space-between'
          align='flex-end'
          style={ { width: '100%' } }
          gap={ rem(16) }
        >
          <ControlPanel clientsCount={ isLoading ? '?' : (data?.pages[0]?.response.paging.total_records_count ?? 0) } />
        </Flex>

        {(isLoading || !containerData) ? (
          <Loader size={ 32 } />
        ) : (
          <Board { ...containerData } />
        )}
      </Stack>
    </Flex>
  );
};
